export function personNameFromEmail(email: string | undefined): string | null {
  if (!email) return null;

  const localPart = email.split("@")[0];
  if (!localPart) return null;

  const name = localPart
    .split(".")
    .map((part) => part.trim())
    .filter((part) => part.length > 0)
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(" ");

  return name.length > 0 ? name : null;
}
